function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
(function(Vac) {
    function flattenSlotParams() {
        var slotParameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var flatParams = {};
        Object.keys(slotParameters).forEach(function(context) {
            var parameterGroup = slotParameters[context];
            if ((typeof parameterGroup === "undefined" ? "undefined" : _type_of(parameterGroup)) !== 'object') {
                return;
            }
            Object.keys(parameterGroup).forEach(function(p) {
                var key = context ? "".concat(context, "_").concat(p) : p;
                flatParams[key] = parameterGroup[p];
            });
        });
        return flatParams;
    }
    Vac.flattenSlotParams = flattenSlotParams;
})(Vac || (Vac = {}));
export var Vac;

//# sourceMappingURL=vac-addon.js.map